// extracted by mini-css-extract-plugin
export default {"MyProfileItem":"_MyProfileItem--dXJfb","Icon":"_Icon--Vsdzs","Text":"_Text--WwxPs"};